import { render, staticRenderFns } from "./table.md?vue&type=template&id=a1c3e44e"
import script from "./table.md?vue&type=script&lang=js"
export * from "./table.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports